"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var react_1 = __importDefault(require("react"));
exports.AnalyticsContext = react_1.default.createContext(new ksys_app_template_1.helpers.AnalyticsHelper(function () {
  return {
    appTemplate: 'unknown',
    appGuid: 'unknown',
    configurationKey: 'unknown'
  };
}));